import React from 'react';
import _ from 'lodash';
import {
  AcademicCapIcon,
  BookOpenIcon,
  CakeIcon, CalendarIcon,
  DocumentDuplicateIcon,
  EnvelopeIcon,
  EyeIcon, FolderIcon,
  GlobeAltIcon,
  LightBulbIcon,
  ShareIcon,
  TrashIcon, UsersIcon
} from '@heroicons/react/24/outline';
import { useUser } from '@lore/auth';
import useDialogConfig from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogConfig';
import useDialogRouter from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogRouter';
import TabBarButton from '../../@communityshare/ui/navigation/TabBarButton';
import TabBar from '../../@communityshare/ui/navigation/TabBar';
import TabBarDropdownMenu from '../../@communityshare/ui/navigation/TabBarDropdownMenu';
import useDialogLauncher from '../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { DialogManager } from '../DialogManager';

export default function SiteTabBar(props) {
  const { project } = props;

  const currentUser = useUser();

  const { id } = useDialogConfig();
  const router = useDialogRouter(id);

  const launch = useDialogLauncher();

  const buttonLinks = _.remove([
    {
      icon: GlobeAltIcon,
      label: 'Networks',
      to: `/networks`
    },
    {
      icon: AcademicCapIcon,
      label: 'Educators',
      to: `/educators`
    },
    {
      icon: UsersIcon,
      label: 'Nearby Partners',
      to: `/partners`
    },
    {
      icon: FolderIcon,
      label: 'Projects',
      to: `/projects`
    },
    {
      icon: CalendarIcon,
      label: 'Events',
      to: `/events`
    }
  ], entry => entry);

  return (
    <TabBar>
      {buttonLinks.map(function(link, index) {
        const active = (
          router.location.pathname.indexOf(link.to) === 0 ||
          link.to.indexOf(router.location.pathname) === 0
        );

        return (
          <TabBarButton
            key={index}
            active={active}
            onClick={() => router.navigate(link.to)}
            icon={link.icon}
            label={link.label}
            to={link.to}
          />
        );
      })}
    </TabBar>
  );
};
